import { memo, useEffect, useState, useRef } from 'react';

import { Input, Checkbox, Row, Col, Spin } from 'antd';
import _, { cloneDeep, throttle } from 'lodash-es';
import styled from 'styled-components';

import Api from '../api';

const IconDivStyle = styled.div`
  .icon {
    background: url('//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-delete.svg') no-repeat center center;
    background-size: 100% 100%;
    &:hover {
      background: url('//static.szlcsc.com/ecp/assets/web/page/www/brand/images/brand-delete-hover-2.svg') no-repeat
        center center;
    }
  }
`;

const IconInput = styled(Input)`
  .search-icon {
    background: url('//static.szlcsc.com/ecp/assets/web/page/www/brand/images/search-icon.svg') no-repeat center center;
    background-size: 100% 100%;
  }
  &:hover {
    .search-icon {
      background: url('//static.szlcsc.com/ecp/assets/web/page/www/brand/images/search-icon-hover.svg') no-repeat center
        center;
    }
  }
`;

const StyledHoverAColor = styled.div`
  a:hover {
    color: #0093e6;
  }
`;

const LetterEnums = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const BrandTypeOptions = [
  {
    label: '国际',
    value: '国际',
  },
  {
    label: '国产',
    value: '国产',
  },
];

const FilterAndList = (props) => {
  const { resourceData } = props;

  const { brandCatalogList, brandData, isLgScreen, leftHeight } = props;

  const [brandDataState, setBrandDataState] = useState(brandData);

  const [activeLetter, setActiveLetter] = useState('#');

  const isFirstRender = useRef(true);
  const [loading, setLoading] = useState(false);
  const [brandKeyword, setBrandKeyword] = useState('');
  const [brandType, setBrandType] = useState([]);
  const [catalogType, setCatalogType] = useState([]);
  const [selectCatalogType, setSelectCatalogType] = useState([]);

  const changeBrandKeyword = (e) => {
    setBrandKeyword(e.target.value);
  };
  const changeBrandType = (checkedValues) => {
    setBrandType(checkedValues);
  };

  const deleteBrandType = (item) => {
    const brandTypeState = cloneDeep(brandType).filter((v) => v !== item);
    setBrandType(brandTypeState);
  };

  const changeCatalogType = (checkedValues) => {
    const selectCatalogTypeState = [];
    brandCatalogList.forEach((item) => {
      if (checkedValues.includes(item.catalogIdStr)) {
        selectCatalogTypeState.push(item);
      }
    });
    setSelectCatalogType(selectCatalogTypeState);
    setCatalogType(checkedValues);
  };

  const deleteCatalogType = (item) => {
    const selectCatalogTypeState = cloneDeep(selectCatalogType).filter((v) => v.catalogIdStr !== item.catalogIdStr);
    setSelectCatalogType(selectCatalogTypeState);
    setCatalogType(selectCatalogTypeState.map((v) => v.catalogIdStr));
  };

  const changeActiveLetter = (item) => {
    setActiveLetter(item);
    const targetElement = document.querySelector(`.${item === '#' ? '井' : item}-content`);
    if (targetElement) {
      const offsetTop = targetElement?.getBoundingClientRect()?.top + window.scrollY - 72 - 39;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  const formatBrandData = (brandDataObj) => {
    let i = 0;
    const arr = [];
    Object.keys(brandDataObj).forEach((item) => {
      brandDataObj[item].map((v) => {
        ++i;
        v.i = i;
        return v;
      });
      arr.push({
        name: item,
        children: brandDataObj[item],
      });
    });
    return arr;
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    reloadBrandList();
  }, [brandKeyword, brandType, catalogType]);

  useEffect(() => {
    const handleScroll = throttle(() => {
      brandDataState?.forEach((chapter) => {
        const element = document.getElementById(chapter.name);
        // 获取元素在可视区域中的位置
        const rect = element?.getBoundingClientRect();
        // 判断是否在可视区域内
        if (rect && rect?.top >= 0 && rect?.bottom <= window.innerHeight) {
          setActiveLetter(chapter.name);
        }
      });
    }, 100);
    window.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const reloadBrandList = async () => {
    try {
      setLoading(true);
      const params = {
        brandKeyword,
        queryPlaceProduction: brandType.length > 0 ? brandType.join(',') : '',
        catalogIds: catalogType.length > 0 ? catalogType.join(',') : '',
      };
      const cleanParams = _.omitBy(params, (value) => value === null || value === undefined || value === '');
      const res = await Api.getBrandDataList(cleanParams).finally(() => {
        setLoading(false);
      });
      if (res.code === 200) {
        setBrandDataState(formatBrandData(res.result.brandMap));
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Spin spinning={loading}>
      <StyledHoverAColor>
        <div className={`flex _lg:w-[1552px] w-[1200px]  m-auto mb-[30px] mt-[30px]`} data-spm="bf">
          <div>
            <div
              className={'w-[280px] bg-white rounded-[20px] mr-[20px] p-[21px] sticky top-[72px] overflow-y-auto'}
              style={{
                maxHeight: leftHeight,
              }}
            >
              <div className={'text-[#000000] text-[18px] mb-[17px] font-bold'}>筛选器</div>
              <IconInput
                placeholder={'请输入品牌名称'}
                className={'w-[230px]'}
                suffix={<span className={'search-icon size-[15px] cursor-pointer'}></span>}
                onBlur={changeBrandKeyword}
                defaultValue={brandKeyword}
                maxLength={50}
              />
              <div className={'mt-[27px] text-[14px] text-[#444444] font-bold mb-[6px]'}>品牌类型</div>
              <Checkbox.Group value={brandType} onChange={changeBrandType}>
                {BrandTypeOptions.map((option) => (
                  <div key={option.value} className={'inline-block mr-[35px]'}>
                    <Checkbox value={option.value}>{option.label}</Checkbox>
                  </div>
                ))}
              </Checkbox.Group>

              <div className={'mt-[27px] text-[14px] text-[#444444] font-bold mb-[6px]'}>目录分类</div>
              <Checkbox.Group value={catalogType} onChange={changeCatalogType}>
                {brandCatalogList.map((option) => (
                  <div key={option.catalogIdStr} className={'mb-[5px]'}>
                    <Checkbox value={option.catalogIdStr}>
                      <span className={'text-[#444444] truncate inline-block w-[220px] translate-y-[6px]'}>
                        {option.catalogNameStr} ({option.skuCount})
                      </span>
                    </Checkbox>
                  </div>
                ))}
              </Checkbox.Group>
            </div>
          </div>

          <div className={`_lg:w-[1252px] w-[900px] bg-white rounded-[20px] p-[25px]`}>
            {[...brandType, ...selectCatalogType].length > 0 && (
              <IconDivStyle>
                <div className={'mb-[20px] wrap'}>
                  <div className={'text-[#444444] text-[14px] font-bold mb-[7px]'}>筛选条件</div>
                  <div className={'flex flex-wrap'}>
                    {brandType.map((item) => {
                      return (
                        <div
                          key={item}
                          className={
                            'flex bg-[#F5F5F7] rounded-[5px] text-[#6C6C6C] text-[14px] pr-[10px] pl-[10px] pt-[5px] pb-[5px] mr-[10px] mb-[10px]'
                          }
                        >
                          {item}
                          <span
                            className={'ml-[14px] size-[13px] cursor-pointer icon inline-block translate-y-[4px]'}
                            onClick={() => deleteBrandType(item)}
                          ></span>
                        </div>
                      );
                    })}
                    {selectCatalogType.map((item) => {
                      return (
                        <div
                          key={item.catalogIdStr}
                          className={
                            'flex bg-[#F5F5F7] rounded-[5px] text-[#6C6C6C] text-[14px] pr-[10px] pl-[10px] pt-[5px] pb-[5px] mr-[10px] mb-[10px]'
                          }
                        >
                          {item.catalogNameStr} ({item.skuCount})
                          <span
                            className={'ml-[14px] size-[13px] cursor-pointer icon inline-block translate-y-[4px]'}
                            onClick={() => deleteCatalogType(item)}
                          ></span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </IconDivStyle>
            )}

            <div className={'text-[#000000] text-[18px] mb-[17px] font-bold'}>品牌筛选</div>
            <div
              className={`flex _lg:mb-[30px] mb-[25px] sticky top-[65px] bg-white h-[55px] pt-[20px] leading-[50px]`}
              style={{ zIndex: 9 }}
            >
              {LetterEnums.map((item) => {
                return (
                  <div
                    key={item}
                    className={`_lg:size-[35px] _lg:mr-[9px] _lg:leading-[35px] _lg:text-[16px] size-[25px] mr-[5px] leading-[25px] text-[14px] cursor-pointer text-[#444444] text-center box-border
                    ${activeLetter === item ? 'bg-[#0093e6] rounded-[5px] text-white font-bold' : 'hover:bg-[#0093e6] hover:rounded-[5px] hover:text-white hover:font-bold'}`}
                    onClick={() => changeActiveLetter(item)}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
            {brandDataState.map((item) => {
              return (
                <div key={item.name} className={`mb-[30px] ${item.name === '#' ? '井' : item.name}-content`}>
                  <div
                    className={'text-[16px] text-[#444444] font-bold pb-[8px] mb-[6px]'}
                    style={{
                      borderBottom: '1px solid #EEEEEE',
                    }}
                    id={item.name}
                  >
                    {item.name} ({item.children.length})
                  </div>
                  <Row className={'text-[#444444] text-[14px] leading-[30px]'}>
                    {item.children.map((v) => {
                      return (
                        <Col key={v.brandId} span={isLgScreen ? 8 : 12}>
                          <a
                            href={`${resourceData?.projectConfigVO.lcscListUrl}/brand/${v.brandId}.html`}
                            target="_blank"
                            data-spm={v.i}
                          >
                            <div className={'pr-[100px] truncate'}>{v.brandName}</div>
                          </a>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              );
            })}
          </div>
        </div>
      </StyledHoverAColor>
    </Spin>
  );
};

export default memo(FilterAndList);
